module.exports = __webpack_public_path__ + "media/assets/images/hheader_movimenta-786e025d8b00d6bd712077105d1f808d.svg";